export default __webpack_public_path__ + "static/media/IMG_5695.f39b3d09.jpeg";